import React from 'react';
import { Badge, Typography } from '@one-thd/sui-atomic-components';
import ReturnDate from './ReturnDate';
import { IFulfillmentGroup } from '../../../models/order-details';
import { getReturnStatus } from '../../../utils/order-details/OrderDetailsUtils';

interface IReturnStatus {
  fg: IFulfillmentGroup;
  variant: string;
}

export const ReturnStatus = ({ fg, variant }: IReturnStatus) => {
  const { isInitiatedReturn, isInProgressReturn, isKeepIt } =
    getReturnStatus(fg);
  return (
    <div
      className={`flex flex-col sui-mb-[16px] ${
        variant === 'card' ? '' : 'sui-min-w-[260px]'
      }`}
    >
      {isKeepIt ? (
        // Keep It ("Refund Issued") returns: label only, no date and no badge.
        <Typography variant="body-base" weight="bold">
          Refund Issued
        </Typography>
      ) : (
        <ReturnDate fg={fg} />
      )}
      {isInitiatedReturn && (
        <Badge variant="subtle" style={{ marginTop: '8px' }} size="small">
          Initiated
        </Badge>
      )}
      {isInProgressReturn && (
        <Badge variant="subtle" style={{ marginTop: '8px' }} size="small">
          Processing
        </Badge>
      )}
    </div>
  );
};
